import {FETCH_HELP_REQUEST, FETCH_HELP_SUCCES, FETCH_HELP_ERROR} from '../constants/Help'
import { jsonGet, errorHandler } from '../utils/Request';

const loadHelp = () => (dispatch) => {
  const apiUrl = '/company/help-applicants/';
  dispatch({
    type: FETCH_HELP_REQUEST,
  });
  return jsonGet(apiUrl)
    .then(json => {
      dispatch({
        type: FETCH_HELP_SUCCES,
        payload: json,
      });
    })
    .catch((e) => {
      dispatch({
        type: FETCH_HELP_ERROR
      });
      errorHandler(e);
    });
};

export { loadHelp };



// WEBPACK FOOTER //
// ./src/actions/HelpActions.js